import { Input } from 'entities/Input'
import { FC, useState } from 'react'
import { withModalHOC } from 'shared/HOCs/withModalHOC'
import { NotificationsCreatorContainer } from './styled'
import { Button } from 'entities/Button'
import { POST } from 'shared/api/POST'

export const Notifications: FC<NotificationsType> = ({ selectedUsers, onClose }) => {
  const [title, setTitle] = useState<string>('')
  const [message, setMessage] = useState<string>('')

  const handleSubmitNotification = async () => {
    if (title?.length && message?.length) {
      const payload = {
        title,
        message,
        recipients: selectedUsers
      }
      await POST.createNotification(payload)
      onClose()
    }
  }

  return (
    <NotificationsCreatorContainer>
      <Input fullWidth label='Title' value={title} onChange={setTitle} />
      <Input fullWidth label='Message' rowsAmount={10} value={message} onChange={setMessage} />
      <Button
        width='100%'
        handleClick={handleSubmitNotification}
        isDisabled={!title?.length || !message?.length}
      >
        Submit
      </Button>
    </NotificationsCreatorContainer>
  )
}

type NotificationsType = {
  selectedUsers: {
    phoneNumber: string | null
    token: 'string'
  }[]
  onClose: () => void
}

export const NotificationsModal = withModalHOC(Notifications)
